import { useState, useMemo } from 'react';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import BigNumber from 'bignumber.js';
import { Process } from '@/types/stake';
import { useCoinInfoContext } from '@/hooks/useCoinInfo';
import { NeedSlippageType } from '@/types/pool';
import { checkDecimal } from '@/utils/num';
/**
 * 滑点相关hook
 */
export const useSlippage = () => {
  const { poolInfo } = usePoolInfoContext();

  const [slippage, setSlippage] = useState(
    // 如果可以让用户滑点，默认值为0.5，否则为0并且不让用户设置滑点
    poolInfo.needSlippage === NeedSlippageType.Need ? '0.5' : '0.5'
  );

  const onChangeSlippage = (v: string) => {
    setSlippage(v);
  };

  return {
    slippage,
    onChangeSlippage,
  };
};

/**
 * 当前token相关数据，包含输入金额和当前选择token信息
 */
export const useCurrentToken = () => {
  const [stakeAmount, setStakeAmount] = useState('');
  const { poolInfo } = usePoolInfoContext();
  const { coinInfoStore } = useCoinInfoContext();
  const [process, setProcess] = useState(Process.None);

  const [currentStakeTokenKey, setCurrentStakeTokenKey] = useState(
    `${poolInfo.chainCode}${poolInfo.whiteList[0].contractAddress}`
  );

  const currentStakeToken = useMemo(
    () => coinInfoStore[currentStakeTokenKey],
    [coinInfoStore, currentStakeTokenKey]
  );

  const stakeAmountValue =
    currentStakeToken?.price && stakeAmount
      ? BigNumber(
          BigNumber(stakeAmount).times(currentStakeToken.price).toFixed(2)
        ).toFormat()
      : '';

  const aprPerDay = BigNumber(poolInfo.apy ?? 0)
    .dividedBy(365)
    .dividedBy(100)
    .times(stakeAmount)
    .times(currentStakeToken.price)
    .toString();

  const aprPreDayAmount = BigNumber(poolInfo.apy ?? 0)
    .dividedBy(365)
    .dividedBy(100)
    .times(stakeAmount)
    .toString();

  const onChangeCurrentToken = (key: string) => {
    setCurrentStakeTokenKey(key);
  };

  const onChangeStakeAmount = (amount: string) => {
    if (!checkDecimal(amount)) {
      return;
    }
    setStakeAmount(amount);
  };

  const onChangeProcess = (step: Process) => {
    setProcess(step);
  };

  return {
    stakeAmount,
    stakeAmountValue,
    currentStakeToken,
    aprPerDay,
    process,
    aprPreDayAmount,
    onChangeStakeAmount,
    onChangeCurrentToken,
    onChangeProcess,
  };
};
